import "./App.css";
import LandingPage from "./LandingPage";

function App() {
    return (
        <div>
            <LandingPage />
            <div></div>
        </div>
    );
}

export default App;
